import AbstractDBModel from './AbstractDBModel'
export default interface User extends AbstractDBModel {
  superAdmin: boolean

  userName: string

  password: string

  firstName: string

  lastName: string

  givenNameInit?: string

  FamilyNameInit?: string

  email: string

  phoneNumber: string

  role: string

  doctorType?: string

  doctorSpecialization?: string

  speciality?: string

  admin: boolean

  multiFactorAuthentication: boolean

  picture?: string

  licenseNumber: string

  /** National Provider Identifier. Providers only, and only used on outbound documents. */
  npi?: string

  specialistLicenseNumber?: string

  endShiftTime?: string

  externalId?: string

  externalUserName?: string

  signInStatus?: string
}

export enum userSignInStatus {
  pending = 'pending',
  waitingPassword = 'waitingPassword',
  active = 'active',
  locked = 'locked',
  changeForcePassword = 'changeForcePassword',
  multiFactorAuthentication = 'multiFactorAuthentication',
}

// an account can still be activated as long as no password was ever set
export const isPendingActivation = (signInStatus?: string): boolean =>
  signInStatus === userSignInStatus.pending || signInStatus === userSignInStatus.waitingPassword

export enum userPasswordResetVerify {
  ok = 'ok',
  error = 'error',
}

export enum userUsernameVerify {
  ok = 'ok',
  error = 'error',
}

export enum userRolesBase {
  doctor = 'doctor',
  nurse = 'nurse',
  medTech = 'medTech',
  socialWorker = 'social-worker',
  technicalAssistant = 'technical-assistant',
  specialist = 'specialist',
  manager = 'manager',
  interpreter = 'interpreter',
  // Owns the supply checklist: which items the medtech is asked to count, and the counts they
  // file. Deliberately its own role rather than a reuse of `manager` — manager is already
  // creatable and carries a patient-facing permission set, so folding stock management into it
  // would hand the checklist to whatever manager accounts already exist.
  // See patient-backend/docs/supply-checklist.md.
  supplyManager = 'supplyManager',
}

export const userRoles = [
  userRolesBase.doctor,
  userRolesBase.nurse,
  userRolesBase.medTech,
  userRolesBase.socialWorker,
  userRolesBase.technicalAssistant,
  userRolesBase.specialist,
  userRolesBase.manager,
  userRolesBase.interpreter,
  userRolesBase.supplyManager,
]

export enum doctorTypesBase {
  primary = 'primary',
  callCenter = 'call_center',
}

export enum loginStatus {
  startShift = 'startShift',
  administrativeWork = 'administrativeWork',
}

export const doctorTypes: string[] = [doctorTypesBase.primary, doctorTypesBase.callCenter]
